import * as $ from "jquery";

declare const TimelineMax: any;
declare const Power2: any;

import ProductModal from './modal';

export default class Products {
	wrapper: HTMLElement;
	slider: any;
	nav: any;
	detailsModal: ProductModal;

	constructor(wrapper: HTMLElement) {
		this.wrapper = wrapper;

		this.initIntro();

		setTimeout(() => {
			this.setWrapperHeight();
		}, 100);

		$(window).resize(() => {
			this.setWrapperHeight();
		});

		this.detailsModal = new ProductModal('product-details');

		const detailsButtons = document.querySelectorAll('.short-description .details');
		for (var i = 0; i < detailsButtons.length; ++i) {
			detailsButtons[i].addEventListener('click', (e) => {
				e.preventDefault();
				const target = <HTMLElement>e.target;
				const pid = target.getAttribute('data-product-id');
				this.loadProductDetails(pid);
				this.detailsModal.show();
			});
		}

		let sliderOpts = {
			slidesPerView: 'auto',
			centeredSlides: true,
			grabCursor: true,
			// slideToClickedSlide: true,

			spaceBetween: -300,
			breakpoints: {
				640: {
					spaceBetween: -24
				}
			},

			watchSlidesProgress: true,
			keyboardControl: true,

			hashnav: true,
			hashnavWatchState: true,

			prevButton: ".pagination-prev",
			nextButton: ".pagination-next",

			onInit: (swiper) => {
				this.slider = swiper;
				this.slideUpdate();
			},

			onSliderMove: (swiper, event) => {
				this.wrapper.removeAttribute('data-hint');
			},

			onTransitionEnd: (swiper) => {
				this.slideUpdate();
			},

			onTransitionStart: (swiper) => {
				let activeEl = <any>swiper.slides[swiper.activeIndex];
				let productId = activeEl.getAttribute("data-product-id");
				this.loadProductDetails(productId);
			},

			onSlideChangeEnd: (swiper) => {
				this.slideUpdate();
			}
		}
		this.slider = new Swiper(this.wrapper, sliderOpts);

		let navOpts = {
			slidesPerView: 'auto',
			centeredSlides: true,

			mousewheelControl: false,
			mousewheelReleaseOnEdges: false,

			touchRatio: 0.2,
	        slideToClickedSlide: true,

	        hashnav: true,
	        hashnavWatchState: true,
		}
		this.nav = new Swiper('nav.products-nav', navOpts);

	    this.slider.params.control = this.nav;
	    this.nav.params.control = this.slider;
	}

	initIntro() {
		// console.log("Intro init!");
		const introTl = new TimelineMax({
			onComplete: () => {
				$('.products-intro__wrapper').remove();
			}
		});
		introTl.to("#clipping > ellipse", 1.2, {
			attr: {
				rx: "0",
				ry: "0"
			},
			ease: Power2.easeOut,
			transformOrigin: "center",
			delay: 0.3
		});

		introTl.to("#product-loading-spinner", 0.5, {
			scale: 0,
			opacity: 0
		}, "-=0.5");
	}

	loadProductDetails(productId: string) {
		const jsonDeets = this.wrapper.querySelector('[data-details="'+productId+'"]');
		let factsEl = <HTMLElement> this.wrapper.querySelector('[data-product-id="'+productId+'"] .freal-nutrition-facts__wrapper');
		if (!factsEl) {
			factsEl = document.createElement('div');
		}
		if (jsonDeets) {
			const details = JSON.parse(jsonDeets.innerHTML);
			this.detailsModal.updateContent(details, factsEl);
		}
	}

	slideUpdate() {
		if (this.slider) {
			let activeEl = <any>this.slider.slides[this.slider.activeIndex];
			let term = activeEl.getAttribute("data-product-category");
			let productId = activeEl.getAttribute("data-product-id");
			this.setBackground(term);
		}
	}

	setWrapperHeight() {
		// Get window height
		// const winHeight = window.innerHeight;
		const winHeight = $(window).height();
		// Load up the desktop header
		const headerNavDesktop = document.querySelector('header.desktop') as HTMLElement;
		const headerNavTouch = document.querySelector('header.touch') as HTMLElement;
		const navHeightDesktop = (headerNavDesktop) ? headerNavDesktop.offsetHeight : 0;
		const navHeightTouch = (headerNavTouch) ? headerNavTouch.offsetHeight : 0;

		const navHeight = (navHeightDesktop > navHeightTouch) ? navHeightDesktop : navHeightTouch;

		// Load up the footer location finder
		const locationFinder = document.getElementById('footer-location-finder');
		// Calc height of footer loc finder
		const locHeight = (locationFinder && window.innerWidth > 1024) ? locationFinder.clientHeight : 0;
		// console.log("Location finder height: " + locHeight);
		// Calc remaining window space
		const newHeight = winHeight - navHeight - locHeight;
		// console.log("New height: " + newHeight);

		// Apply new height value to viewport element
		this.wrapper.style.height = newHeight + "px";
	}

	setBackground(termId) {
		// console.log("Setting background to term: " + termId);
		$('.backgrounds > div').each((i, el) => {
			let term = $(el).attr('data-product-category');
			if (term == termId) {
				$(el).attr('data-status', 'active');
			} else {
				$(el).removeAttr('data-status');
			}
		});
	}
}